// @flow

import _ from 'lodash';
import type { JSableInterface } from '../';

export const JSableMixin = (superclass: Class<any>) =>
class JSable extends superclass implements JSableInterface {
	toJS (): any {
		return _(this)
			.omitBy((v, k) => this._toJSOmit(v, k))
			.mapValues((v, k) => this._toJSRead(v, k))
			.value();
	}
	_toFromJSOmit (v: any, k: string, prop: ?JSableInterface, js: ?Object): boolean {
		_.noop(v, k, prop, js);
		return false;
	}
	_toJSOmit (v: JSableInterface, k: string): boolean {
		return this._toFromJSOmit(v, k)
			|| !(v && v.toJS);
	}
	_toJSRead (v: JSableInterface, k: string): any {
		_.noop(k);
		return v.toJS();
	}

	fromJS (js: Object): void {
		_(js)
			.omitBy((v, k) => this._fromJSOmit(v, this[k], k, js))
			.mapValues((v, k) => this._fromJSWrite(v, this[k], k, js))
			.value();
	}
	_fromJSOmit (v: any, prop: JSableInterface, k: string, js: Object): boolean {
		return this._toFromJSOmit(v, k, prop, js)
			|| !(prop && prop.fromJS)
			|| v === undefined;
	}
	_fromJSWrite (v: any, prop: JSableInterface, k: string, js: Object): any {
		_.noop(k, js);
		return prop.fromJS(v);
	}
};

export const JSable = JSableMixin(class {});

